import React, { useRef, useEffect } from 'react';
import { Animated, StyleSheet } from 'react-native';

interface Props {
  start: boolean;
  animationTime?: number; // seconds
  onComplete?: () => void;
  children?: React.ReactNode;
}

export default function FadeOutOverlay({
  start,
  animationTime = 2,
  onComplete,
  children,
}: Props) {
  const opacity = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    if (start) {
      Animated.timing(opacity, {
        toValue: 0,
        duration: animationTime * 1000,
        useNativeDriver: true,
      }).start(() => {
        onComplete?.();
      });
    }
  }, [start]);

  return (
    <Animated.View style={[StyleSheet.absoluteFill, { opacity }]}>
      {children}
    </Animated.View>
  );
}
